module.exports = __webpack_public_path__ + "img/3_2.838b53c7.png";